var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.328 23.154v-.126c0-1.061 0-1.592.206-1.997.182-.356.472-.646.828-.828.405-.206.936-.206 1.997-.206h4.042c1.061 0 1.592 0 1.997.206.357.182.646.472.828.828.207.405.207.936.207 1.997v.126m-10.105 0a1.263 1.263 0 1 0 0 2.527 1.263 1.263 0 0 0 0-2.527Zm10.105 0a1.263 1.263 0 1 0 0 2.527 1.263 1.263 0 0 0 0-2.527Zm-5.053 0a1.263 1.263 0 1 0 0 2.527 1.263 1.263 0 0 0 0-2.527Zm0 0V16.84m-3.79 0h7.58c.588 0 .882 0 1.114-.096.31-.129.556-.374.684-.684.096-.232.096-.526.096-1.115s0-.883-.096-1.115a1.263 1.263 0 0 0-.684-.684c-.232-.096-.526-.096-1.114-.096h-7.58c-.588 0-.882 0-1.114.097-.31.128-.556.374-.684.683-.096.232-.096.526-.096 1.115s0 .883.096 1.115c.128.31.374.555.684.684.232.096.526.096 1.115.096Z",
    stroke: "#0086C9",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgApi;